import { render, staticRenderFns } from "./CollectionCardTitle.vue?vue&type=template&id=59f992d8&"
import script from "./CollectionCardTitle.vue?vue&type=script&lang=ts&"
export * from "./CollectionCardTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports